import React from "react"
import { safariAnimationFix } from "../utils/Transition"
import logoWhite from "@shared/assets/filmustage-logo-white.svg"

/**
 * Filmustage wordmark for the site header.
 *
 * Imported from /shared/assets - the same file the app's navbar renders - so a
 * rebrand touches one artwork file instead of every surface. `@shared` is aliased
 * in gatsby-node.js because the Docker build context is apps/landing, where the
 * folder lives at an absolute /shared rather than two levels up (see shared-dir.js).
 *
 * White variant: this header always sits on the dark site background. The app,
 * which has both themes, picks white or black at render time.
 *
 * 179x24 is not a free choice - it is the size the app's navbar renders the same
 * wordmark at (rsuite <Icon size='2x'> resolves to a 24px box), measured rather than
 * guessed. The two surfaces sit side by side in a user's tabs, and this header used
 * to draw it at 21px, which read as a visibly smaller logo. 179 = 24 x 1060/142, so
 * the aspect ratio stays exact. Change one only if you change the other.
 */
function Logo() {
  return (
    <img
      src={logoWhite}
      alt="Filmustage"
      className="w-[179px] h-[24px] opacity-80 hover:opacity-100 transition duration-300 ease-in-out"
      style={safariAnimationFix}
    />
  )
}

export default Logo
